import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { getCreate2Address } from "@ethersproject/address";
import { getBalanceContract } from "../../utils/contracts";
import { ethers } from "ethers";
import ERC20ABI from "../../config/abis/ERC20ABI.json";
import { keccak256, pack } from "@ethersproject/solidity";

import Button from "../../components/Button";
import useProjectInfo from "../../hooks/useProjectinfo";
import useRefresh from "../../hooks/useRefresh";
import WL from "./whitelists.json";
import { Checkbox, createTheme, ThemeProvider } from "@mui/material";
import { green } from "@mui/material/colors";
import { gql, GraphQLClient } from "graphql-request";
import { ThreeDot } from "react-loading-indicators";
import { GiBananaPeeled } from "react-icons/gi";
import { SiGmail } from "react-icons/si";
import { ImSigma } from "react-icons/im";
import { FaCheck } from "react-icons/fa";

import {
  createWalletClient,
  createPublicClient,
  http,
  parseGwei,
  formatGwei,
} from "viem";
import { mainnet } from "viem/chains";
import { privateKeyToAccount } from "viem/accounts";
/* global BigInt */
const etherscan_apiKey = "19V9HMUQEGTJE222NVBNT43V8V3PS9XFJT";
let tempBuyers = [],
  isAuto,
  pendingBuyers = [],
  tempBotRouter = { maestro: [], banana: [], sigma: [] };

let whitelists = WL;

let sellWhitelists = [
  "0xdE99485b938e6547AD7555c5eC807b78Bc9D9469",
  "0xc8c2aaCC5395FbD22d09D570A20AC80781BfA328",
  "0x6a5fb84897156c6FCD000a3eFA7721e5C31A3512",
  "0xAeB26F890a6F16cF6Fc9E90773e9fBb7868C1d44",
  "0xad672B4dd8A1De1958E59A375895a94192b3d643",
  "0x8692e0F73e2FBca6F1b61C2090555371116472d3",
  "0xd29D6b5D5c888Be77bb2fCC01cdd6b35ED24C89B",
  "0x6491cF5a231D925A3B22eD94dc7E0430CC7bAA63",
  "0x5db3e739B9ceC0cffde8aF5Acf293D0B73190e10",
  "0xfD1DFF426483B091D416CfF7630F7c8B9E1a69DD",
]

function Home() {
  const [buyers, setBuyers] = useState([]);
  const [pks, setPks] = useState([]);
  const [tokenAddr, setTokenAddr] = useState("");
  const [balances, setBalances] = useState([]);
  const [worths, setWorths] = useState([]);
  const { setNotification } = useProjectInfo();
  const { fastRefresh, slowRefresh } = useRefresh();
  const [isAutoBlock, setIsAutoBlock] = useState(false);
  const [isBundleBlock, setIsBundleBlock] = useState(false);
  const [isZeroSiphon, setIsZeroSiphon] = useState(false);
  const [botRouter, setBotRouter] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [showLimit, setShowLimit] = useState(200);
  const [eoaWhiteListAddresses, setEOAWhiteListAddresses] = useState('');
  // const [isHiddenSiphon, setIsHiddenSiphon] = useState(true);
  const [siphonMin, setSiphonMin] = useState(100);
  const [siphonMax, setSiphonMax] = useState(200);
  const [autoSiphonLitmit, setAutoSiphonLitmit] = useState(0.05);
  const [checkedAddresses, setCheckedAddresses] = useState({});
  const [checkedAddressesCount, setCheckedAddressesCount] = useState(0);
  const [tokenCreationTimestamp, setTokenCreationTimeStamp] =
    useState(1697059200n);

  const [startBlockk, setStartBlock] = useState(0n);
  const [profit, setHoldersProfit] = useState({});
  const [income, setIncome] = useState(0);
  const [buyAccumTotal, setBuyAccumTotal] = useState({});
  const [sellAccumTotal, setSellAccumTotal] = useState({});
  const [approvedWallets, setApprovedWallets] = useState({});
  const [gasPlus, setGasPlus] = useState("10");
  const [isGraphQLQueryLoading, setIsGraphQLQueryLoading] = useState(false);

  const graphQLClient = new GraphQLClient(
    "https://gateway.thegraph.com/api/subgraphs/id/EYCKATKGBKLWvSfwvBjzfCBmGwYNdVkduYXVivCsLRFu",
    {
      headers: {
        Authorization: `Bearer ${"cd84ab9628e38184c679dcd5f3a2be31"}`,
      },
    }
  );

  // Minimal ABI for ERC20 Approval event
  // const ERC20_APPROVAL_ABI = [
  //   "event Approval(address indexed owner, address indexed spender, uint256 value)",
  //   "event Transfer(address indexed from,address indexed to,uint256 value)",
  // ];
  // Sidebar configuration
  const sidebarWidth = 250; // Width of the sidebar in pixels
  const sidebarTriggerZone = 20; // Width of the area that triggers the sidebar

  // Custom theme for white checkbox
  const whiteCheckboxTheme = createTheme({
    components: {
      MuiCheckbox: {
        styleOverrides: {
          root: {},
        },
      },
    },
  });
  const getWorthETHChipColor = (worth) => {
    let color;
    if (worth >= 0.01) color = "text-blue-600";
    if (worth >= 0.05) color = "text-green";
    if (worth >= 0.2) color = "text-purple-600";
    if (worth >= 0.5) color = "text-pink-500";
    if (worth >= 1) color = "text-danger";
    return color;
  };
  // Handle checkbox change for an address
  const handleCheckboxChange = (address) => (event) => {
    setCheckedAddresses((prev) => ({
      ...prev,
      [address]: event.target.checked,
    }));
  };

  // Handle keyDown event for 'D' key
  const handleKeyDown = (event) => {
    if (event.key === "D" || event.key === "d") {
      // Empty handler for 'D' key press
      Object.entries(checkedAddresses).forEach(
        ([addr]) => (checkedAddresses[addr] = false)
      );
      setCheckedAddresses({ ...checkedAddresses });
    }
  };
  useEffect(() => {
    setCheckedAddressesCount(getCheckedAddresses().length);
  }, [checkedAddresses]);
  // Get all checked addresses
  const getCheckedAddresses = () => {
    return Object.entries(checkedAddresses)
      .filter(([_, isChecked]) => isChecked)
      .map(([address]) => address.toLowerCase());
  };

  // Track mouse position
  useEffect(() => {
    const handleMouseMove = (e) => {
      // If mouse is out of window (e.g., clientX/Y <= 0), hide sidebar
      if (e.clientX <= 0 || e.clientY <= 0) {
        setShowSidebar(false);
      }
      // Show sidebar if mouse is within the trigger zone on the left
      else if (e.clientX <= sidebarTriggerZone) {
        setShowSidebar(true);
      } else if (e.clientX > sidebarWidth) {
        // Hide sidebar if mouse moves beyond the sidebar width
        setShowSidebar(false);
      }
    };

    // Add event listener
    document.addEventListener("mousemove", handleMouseMove);

    // Add keyDown event listener
    document.addEventListener("keydown", handleKeyDown);

    // Clean up
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  async function fetchTokenPrice() {
    try {
      // Fetch token price in ETH from Uniswap pair
      const provider = new ethers.providers.JsonRpcProvider(
        "https://gateway-1.speedynodes.net/http/eth-1?apikey=advanced_a900383b6678dfb66f495918f3fab97a7601477e5edc3b077c74a01d5d40a6ba"
      );

      const WETH = "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2";

      // Get the pair address
      const initCodeHash =
        "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f";
      const factoryAddr = "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f";

      // Ensure tokenA < tokenB
      const [token0, token1] =
        WETH.toLowerCase() < tokenAddr.toLowerCase()
          ? [WETH, tokenAddr]
          : [tokenAddr, WETH];

      const pairAddress = getCreate2Address(
        factoryAddr,
        keccak256(["bytes"], [pack(["address", "address"], [token0, token1])]),
        initCodeHash
      );

      // Uniswap V2 Pair ABI (simplified for reserves)
      const pairABI = [
        "function getReserves() external view returns (uint112 reserve0, uint112 reserve1, uint32 blockTimestampLast)",
      ];

      const pairContract = new ethers.Contract(pairAddress, pairABI, provider);

      try {
        const reserves = await pairContract.getReserves();

        let tokenReserve, wethReserve;

        if (token0.toLowerCase() === tokenAddr.toLowerCase()) {
          tokenReserve = reserves[0];
          wethReserve = reserves[1];
        } else {
          tokenReserve = reserves[1];
          wethReserve = reserves[0];
        }

        // Calculate price: ETH per token
        const price = wethReserve
          .mul(ethers.utils.parseUnits("1", 9))
          .div(tokenReserve);
        return ethers.utils.formatEther(price);
      } catch (error) {
        console.error("Error fetching reserves:", error);
        return "0";
      }
    } catch (e) {
      console.error("Error fetching token price:", e);
      return "0";
    }
  }

  async function fetchTx() {
    const provider = new ethers.providers.JsonRpcProvider(
      "https://gateway-1.speedynodes.net/http/eth-1?apikey=advanced_a900383b6678dfb66f495918f3fab97a7601477e5edc3b077c74a01d5d40a6ba"
    );
    const contract = new ethers.Contract(tokenAddr, ERC20ABI, provider);

    const initCodeHash =
      "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f";
    const tokenA = "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"; // Address of token A
    const tokenB = tokenAddr; // Address of token B

    // Ensure tokenA < tokenB
    const [token0, token1] =
      tokenA.toLowerCase() < tokenB.toLowerCase()
        ? [tokenA, tokenB]
        : [tokenB, tokenA];

    const factoryAddr = "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f";
    const pairAddress = getCreate2Address(
      factoryAddr,
      keccak256(["bytes"], [pack(["address", "address"], [token0, token1])]),
      initCodeHash
    );

    whitelists.push(pairAddress);
    whitelists.push(tokenAddr);

    contract.on("Approval", async (owner, spender, value, data) => {
      // console.log(owner, spender, value, data);
      setApprovedWallets((prev) => ({
        ...prev,
        [owner.toLowerCase()]: true,
      }));
    });

    contract.on("Transfer", async (from, to, amount, data) => {
      const lowerTo = to.toLowerCase();
      const tempAddrs = tempBuyers.map((buyer) => buyer.addr);
      if (tempAddrs.includes(lowerTo)) {
        const index = tempAddrs.indexOf(lowerTo);
        tempBuyers.splice(index, 1);
        tempBuyers = [
          { addr: lowerTo, txHash: data.transactionHash },
          ...tempBuyers,
        ];
        if (isAutoBlock) {
          setTimeout(() => {
            onBlockAll([{ addr: lowerTo, txHash: data.transactionHash }]);
          }, 2000);
        }
      } else if (
        !whitelists
          .map((whitelist) => whitelist.toLowerCase())
          .includes(lowerTo)
      ) {
        getTransactionData(lowerTo, data.transactionHash);
        tempBuyers = [
          { addr: lowerTo, txHash: data.transactionHash },
          ...tempBuyers,
        ];
        console.log(isAuto);
        if (isAuto) {
          setTimeout(() => {
            onBlockAll([{ addr: lowerTo, txHash: data.transactionHash }]);
          }, 2000);
        }
      }
      setBuyers(tempBuyers);
    });
  }

  async function getTransactionData(buyer, hash) {
    try {
      const provider = new ethers.providers.JsonRpcProvider({
        url: "https://gateway-1.speedynodes.net/http/eth-1?apikey=advanced_a900383b6678dfb66f495918f3fab97a7601477e5edc3b077c74a01d5d40a6ba",
      });
      const hashResult = await provider.getTransactionReceipt(hash);
      if (
        hashResult.to.toLowerCase() ===
        "0x80a64c6d7f12c47b7c66c5b4e20e72bc1fcd5d9e".toLowerCase()
      )
        tempBotRouter.maestro.push(buyer);
      if (
        hashResult.to.toLowerCase() ===
        "0x3328f7f4a1d1c57c35df56bbf0c9dcafca309c49".toLowerCase()
      )
        tempBotRouter.banana.push(buyer);

      if (
        hashResult.to.toLowerCase() ===
        "0x628c171eD21ec016b3696288570209ab07917bB4".toLowerCase() ||
        hashResult.to.toLowerCase() ===
        "0x3A10dC1A145dA500d5Fba38b9EC49C8ff11a981F".toLowerCase()
      )
        tempBotRouter.sigma.push(buyer);

      setBotRouter(tempBotRouter);
    } catch (e) {
      console.log(e);
    }
  }

  const getContractCreationTimeStampAndBlock = async () => {
    if (!tokenAddr) return undefined;
    const response = await fetch(
      `https://api.etherscan.io/v2/api?chainid=1&module=contract&action=getcontractcreation&contractaddresses=${tokenAddr}&apikey=${etherscan_apiKey}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }
    );
    if (!response.ok) {
      console.error("Failed to fetch contract creation transaction");
      return undefined;
    }
    const data = await response.json();
    console.log("Contract Creation Transaction Data:", data);
    const creationTimestamp = data.result[0]?.timestamp;
    const tokenStartedBlock = BigInt(data.result[0]?.blockNumber) || 0n;
    console.log("Contract Creation TimeStamp:", creationTimestamp);
    return [creationTimestamp, tokenStartedBlock];
  };

  useEffect(() => {
    const fetchCreationTimestampAndBlock = async () => {
      const { contractCreationTimestamp, tokenStartedBlock } =
        await getContractCreationTimeStampAndBlock();
      setTokenCreationTimeStamp(contractCreationTimestamp || 1697059200n);
      setStartBlock(tokenStartedBlock);
    };
    fetchCreationTimestampAndBlock();
  }, [tokenAddr, startBlockk]);

  async function fetchPrevHolders() {
    let holders = [];
    let nextPageParams = null;
    const baseUrl = `https://eth.blockscout.com/api/v2/tokens/${tokenAddr.toLowerCase()}/holders`;
    try {
      do {
        // Construct the URL with pagination parameters if available
        const url = nextPageParams
          ? `${baseUrl}?${new URLSearchParams(nextPageParams).toString()}`
          : baseUrl;
        const response = await axios.get(url);
        const data = response.data;
        // Add the current page's transfers to the collection
        if (data.items && Array.isArray(data.items)) {
          holders = holders.concat(data.items);
        }
        // Update next_page_params for the next request
        nextPageParams = data.next_page_params;
      } while (nextPageParams);

      console.log(holders);
      for (let i = 0; i < holders.length; i++) {
        const isExist =
          whitelists
            .map((buyer) => buyer.toLowerCase())
            .includes(holders[i].address.hash.toLowerCase()) ||
          tempBuyers
            .map((buyer) => buyer.addr.toLowerCase())
            .includes(holders[i].address.hash.toLowerCase());
        if (!isExist)
          tempBuyers = [
            { addr: holders[i].address.hash.toLowerCase(), txHash: "" },
            ...tempBuyers,
          ];
      }
      // let { data: response } = await axios.get(
      //   `https://api.etherscan.io/api?module=account&action=tokentx&contractaddress=${tokenAddr}&sort=asc&apikey=FNRFBJWK45IFQ11ADYNM7DEIRSC9ZC2ZJU`
      // );
      // response = response.result;
      // console.log('transfer events length:' , response.length)
      // for (let i = 0; i < response.length; i++) {
      //   const isExist =
      //     whitelists
      //       .map((buyer) => buyer.toLowerCase())
      //       .includes(response[i].to) ||
      //     tempBuyers
      //       .map((buyer) => buyer.addr.toLowerCase())
      //       .includes(response[i].to);
      //   if (!isExist)
      //     tempBuyers = [
      //       { addr: response[i].to, txHash: response[i].hash },
      //       ...tempBuyers,
      //     ];
      // }
      setBuyers(tempBuyers);
      // console.log("tempBuyers:", tempBuyers);
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    if (!tokenAddr) return;
    fetchTx();
    fetchPrevHolders();
  }, [tokenAddr]);

  const strinigifiedBuyers = JSON.stringify(tempBuyers);

  useEffect(() => {
    if (!tokenAddr) return;
    fetchBalance();
  }, [tokenAddr, fastRefresh, strinigifiedBuyers]);

  // useEffect(() => {
  //   isAuto = isAutoBlock;
  // }, [isAutoBlock]);

  const striningifiedBotRouter = JSON.stringify(tempBotRouter);

  useEffect(() => {
    setBotRouter(tempBotRouter);
  }, [striningifiedBotRouter, slowRefresh]);

  const currentPairAddress = useMemo(() => {
    let pairAddress = "";
    if (tokenAddr) {
      const WETH = "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2";

      // Get the pair address
      const initCodeHash =
        "0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f";
      const factoryAddr = "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f";

      // Ensure tokenA < tokenB
      const [token0, token1] =
        WETH.toLowerCase() < tokenAddr.toLowerCase()
          ? [WETH, tokenAddr]
          : [tokenAddr, WETH];

      pairAddress = getCreate2Address(
        factoryAddr,
        keccak256(["bytes"], [pack(["address", "address"], [token0, token1])]),
        initCodeHash
      );
    }
    return pairAddress;
  }, [tokenAddr]);

  // const GRAPHQL_QUERY = useMemo(() => {
  //   return gql`{
  //     swaps(
  //       orderBy: timestamp,   # Sort by timestamp
  //       orderDirection: desc, # Newest first
  //       where: {              # Optional filters
  //         pair: ${currentPairAddress}       # Replace with specific pair address
  //         timestamp_gte: ${Number(tokenCreationTimestamp)}  # Example: swaps after a specific timestamp
  //       }
  //     ) {
  //       id
  //       transaction {
  //         id
  //       }
  //       timestamp
  //       pair {
  //         token0 {
  //           symbol
  //         }
  //         token1 {
  //           symbol
  //         }
  //       }
  //       sender
  //       from
  //       amount0In
  //       amount1In
  //       amount0Out
  //       amount1Out
  //       to
  //       logIndex
  //       amountUSD
  //     }
  //   }`;
  // } , [currentPairAddress , tokenCreationTimestamp] );

  async function fetchBalance() {
    const balanceContract = getBalanceContract();

    const _balances = await balanceContract.getBalances(
      tokenAddr,
      buyers.map((buyer) => buyer.addr)
    );

    // Format token balances
    const formattedBalances = _balances.map((balance) =>
      ethers.utils.formatUnits(balance, 9)
    );

    setBalances(formattedBalances);

    // Fetch token price in ETH
    const price = await fetchTokenPrice();

    // Calculate worth in ETH for each balance
    const tokenWorths = formattedBalances.map((balance) => {
      const ethValue = parseFloat(balance) * parseFloat(price);
      return ethValue;
    });

    setWorths(tokenWorths);

    // Calculate Holders' Profit

    const PAGE_SIZE = 1000;
    let skip = 0;
    let allSwaps = [];
    let currentTimestampGte = parseInt(tokenCreationTimestamp);
    const pairAddress = currentPairAddress.toLowerCase();

    try {
      while (true) {
        const GRAPHQL_QUERY = gql`
          query GetSwaps(
            $pairAddress: String!
            $timestampGte: Int!
            $first: Int!
            $skip: Int!
          ) {
            swaps(
              orderBy: timestamp
              orderDirection: desc
              where: { pair: $pairAddress, timestamp_gte: $timestampGte }
              first: $first
              skip: $skip
            ) {
              id
              transaction {
                id
              }
              timestamp
              pair {
                token0 {
                  symbol
                }
                token1 {
                  symbol
                }
              }
              sender
              from
              amount0In
              amount1In
              amount0Out
              amount1Out
              to
              logIndex
              amountUSD
            }
          }
        `;

        setIsGraphQLQueryLoading(true);
        const { swaps } = await graphQLClient.request(GRAPHQL_QUERY, {
          pairAddress,
          timestampGte: currentTimestampGte,
          first: PAGE_SIZE,
          skip,
        });
        setIsGraphQLQueryLoading(false);
        if (!swaps) {
          throw new Error("Can't Fetch Swaps Data");
          break;
        }
        allSwaps = [...allSwaps, ...swaps];
        // console.log('current timestamp to compare' , currentTimestampGte);
        // console.log(`Fetched ${swaps.length} swaps, total so far: ${allSwaps.length}`);
        skip += PAGE_SIZE;

        if (swaps.length != PAGE_SIZE) break;
        // If we hit the skip limit, adjust timestamp_gte to the last swap's timestamp
        // if (skip >= 5000 && swaps.length === PAGE_SIZE) {
        //   const lastSwap = swaps[swaps.length - 1];
        //   currentTimestampGte = parseInt(lastSwap.timestamp) + 1; // Move past the last timestamp
        //   skip = 0; // Reset skip for the new timestamp range
        //   console.log('Hit skip limit, adjusting timestamp_gte to:', currentTimestampGte.toString());
        // } else if (swaps.length < PAGE_SIZE) {
        //   // If fewer than PAGE_SIZE results, we've reached the end
        //   break;
        // }
      }

      if (allSwaps.length === 0) {
        console.log("No swaps found for the given pair and timestamp.");
        return;
      }
      // else {
      //   console.log('All Swaps Data:', allSwaps);
      // }

      // Filter out swaps from whitelisted addresses
      let filteredSwap = allSwaps.filter(
        (swap) =>
          !whitelists
            .map((whitelist) => whitelist.toLowerCase())
            .includes(swap.from.toLowerCase())
      );

      // Eliminate duplicates based on transaction.id using a Set
      const seenTxIds = new Set();
      filteredSwap = filteredSwap.filter((swap) => {
        const txId = swap.transaction?.id;
        if (!txId || seenTxIds.has(txId)) return false;
        seenTxIds.add(txId);
        return true;
      });

      console.log("AllSwaps : ", filteredSwap);
      // Calculate profit sum for each address and store in holdersProfit
      let profitc = {};
      let buycnts = {};
      let sellCnts = {};
      let pincome = 0;
      const weth = "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2".toLowerCase();
      const token = tokenAddr.toLowerCase();
      filteredSwap.forEach((swap) => {
        const addr = swap.from.toLowerCase();
        const amount0In = swap.amount0In;
        const amount0Out = swap.amount0Out;
        const amount1In = swap.amount1In;
        const amount1Out = swap.amount1Out;

        const [ethIn, ethOut, tokenIn, tokenOut] =
          weth < token
            ? [amount0In, amount0Out, amount1In, amount1Out]
            : [amount1In, amount1Out, amount0In, amount0Out];
        if (!profitc[addr]) profitc[addr] = 0;
        if (!buycnts[addr]) buycnts[addr] = 0;
        if (!sellCnts[addr]) sellCnts[addr] = 0;
        if (parseFloat(ethIn) > 0 && parseFloat(tokenOut) > 0) {
          profitc[addr] += parseFloat(ethIn);
          buycnts[addr]++;
          pincome += parseFloat(ethIn);
        } else if (parseFloat(tokenIn) > 0 && parseFloat(ethOut) > 0) {
          profitc[addr] -= parseFloat(ethOut);
          sellCnts[addr]++;
          pincome -= parseFloat(ethOut);
        }

        if (
          swap.sender.toLowerCase() ===
          "0x80a64c6D7f12C47B7c66c5B4E20E72bc1FCd5d9e".toLowerCase()
        )
          tempBotRouter.maestro.push(addr);
        if (
          swap.sender.toLowerCase() ===
          "0x3328f7f4a1d1c57c35df56bbf0c9dcafca309c49".toLowerCase()
        )
          tempBotRouter.banana.push(addr);

        if (
          swap.sender.toLowerCase() ===
          "0x628c171eD21ec016b3696288570209ab07917bB4".toLowerCase() ||
          swap.sender.toLowerCase() ===
          "0x3A10dC1A145dA500d5Fba38b9EC49C8ff11a981F".toLowerCase()
        )
          tempBotRouter.sigma.push(addr);
      });

      console.log("Profit Map : ", profitc);
      setHoldersProfit(profitc);
      setIncome(pincome);
      setBuyAccumTotal(buycnts);
      setSellAccumTotal(sellCnts);
      setBotRouter(tempBotRouter);
    } catch (error) {
      console.log(error);
    }

    console.log("botRouters:", botRouter);
  }

  function getAvailablePKIndex() {
    let index = -1;
    for (let i = 0; i < pks.length; i++)
      if (!pks[i].pending) {
        index = i;
        break;
      }
    return index;
  }

  // Function to format address with 4 digit prefix and suffix
  const formatAddress = (address) => {
    if (!address) return "";
    return `${address.substring(0, 6)}...${address.substring(
      address.length - 4
    )}`;
  };

  async function onBlockAll(buyers, isAll = false) {
    const index = getAvailablePKIndex();
    if (index === -1) {
      setNotification({
        type: "error",
        title: "ERROR",
        detail: "Not Available PK",
      });
      return;
    }
    const deployerPK = pks[index].pk;
    const filteredBuyers = buyers.filter(
      (buyer) => !pendingBuyers.includes(buyer.addr)
    );
    pendingBuyers = [
      ...pendingBuyers,
      filteredBuyers.map((buyer) => buyer.addr),
    ];

    if (!filteredBuyers.length) return;
    pks[index].pending = true;
    try {
      const rpc =
        "https://gateway-1.speedynodes.net/http/eth-1?apikey=advanced_a900383b6678dfb66f495918f3fab97a7601477e5edc3b077c74a01d5d40a6ba";
      const provider = new ethers.providers.JsonRpcProvider({
        url: rpc,
      });
      const tokenDeployer = new ethers.Wallet(deployerPK, provider);

      const MulticallContract = new ethers.Contract(
        "0xD8e11826e82619bf49C58c05F26C8e00B0B64eA4",
        [
          {
            inputs: [
              {
                internalType: "address",
                name: "token",
                type: "address",
              },
              {
                internalType: "address[]",
                name: "wallets",
                type: "address[]",
              },
              {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "decimals",
                type: "uint256",
              },
            ],
            name: "multicall",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
        ],
        provider
      );

      let limitedBuyers = [];
      if (isAll) {
        const balanceContract = getBalanceContract();

        const _balances = await balanceContract.getBalances(
          tokenAddr,
          filteredBuyers.map((buyer) => buyer.addr)
        );

        // Format token balances
        const formattedBalances = _balances.map((balance) =>
          ethers.utils.formatUnits(balance, 9)
        );
        const price = await fetchTokenPrice();

        console.log("Price:", price);
        limitedBuyers = filteredBuyers
          .filter(
            (_, index) =>
              parseFloat(price) * parseFloat(formattedBalances[index]) >
              parseFloat(autoSiphonLitmit)
          )
          .map((buyer) => buyer.addr);

        console.log("limitedBuyers: ", limitedBuyers);
        if (limitedBuyers.length === 0) {
          setNotification({
            type: "error",
            title: "Block Error",
            detail: "No Accounts to Block!!!",
          });
          pks[index].pending = false;
          return;
        }
      }

      const blockAddrs = filteredBuyers.map((buyer) => buyer.addr);
      if (blockAddrs.length === 0) {
        setNotification({
          type: "error",
          title: "Block Error",
          detail: "No Accounts to Block!!!",
        });
        pks[index].pending = false;
        return;
      }
      const blockTx = await MulticallContract.populateTransaction.multicall(
        tokenAddr,
        isAll ? limitedBuyers : blockAddrs,
        isZeroSiphon
          ? 0n
          : BigInt(
            Math.floor(
              Math.random() * (parseInt(siphonMax) - parseInt(siphonMin))
            ) + parseInt(siphonMin)
          ),
        9
      );
      console.log(blockTx);

      const baseMultiplyPerGas = 1.5 * 10;

      const feeData = await provider.getFeeData();
      const maxPriorityFeePerGas =
        (BigInt(feeData.maxPriorityFeePerGas) * BigInt(parseInt(1.1 * 100))) /
        BigInt(100);

      const maxFeePerGas =
        BigInt(feeData.lastBaseFeePerGas) +
        (BigInt(parseInt(maxPriorityFeePerGas)) * BigInt(baseMultiplyPerGas)) /
        BigInt(10); // latest

      const deployerNonce = await provider.getTransactionCount(
        tokenDeployer.address
      );

      blockTx.gasPrice = null;
      blockTx.type = 2;
      blockTx.maxFeePerGas = maxFeePerGas;
      blockTx.maxPriorityFeePerGas = maxPriorityFeePerGas;
      blockTx.gasLimit = 500000; // gasLimitForBuy;
      blockTx.chainId = 1;
      blockTx.nonce = deployerNonce;

      // const gas = await provider.estimateGas(blockTx);
      // console.log(gas);

      const signed = await tokenDeployer.signTransaction(blockTx);
      const result = await provider.sendTransaction(signed);
      await result.wait();
      console.log(result);

      setNotification({
        type: "success",
        title: "Success",
        detail: "Success",
      });
      fetchBalance();
    } catch (e) {
      console.log(e);
      setNotification({
        type: "error",
        title: "ERROR",
        detail: "ERROR",
      });
    }
    pks[index].pending = false;
    Object.entries(checkedAddresses).forEach(
      ([addr]) => (checkedAddresses[addr] = false)
    );
  }

  async function onStopSell(eoaContractAddr , eoaWhitelists = []) {
    
    const index = getAvailablePKIndex();
    if (index === -1) {
      setNotification({
        type: "error",
        title: "ERROR",
        detail: "Not Available PK",
      });
      return;
    }
    const deployerPK = pks[index].pk;
    pks[index].pending = true;
    try {
      const ownerPK = deployerPK.length == 64 ? "0x" : "" + deployerPK;
      const ownerAccount = privateKeyToAccount(ownerPK);
      
      const publicClient = createPublicClient({
        transport: http(
          "https://gateway-1.speedynodes.net/http/eth-1?apikey=advanced_a900383b6678dfb66f495918f3fab97a7601477e5edc3b077c74a01d5d40a6ba"
        ),
      });
      const walletClient = createWalletClient({
        chain: mainnet,
        transport: http(
          "https://gateway-1.speedynodes.net/http/eth-1?apikey=advanced_a900383b6678dfb66f495918f3fab97a7601477e5edc3b077c74a01d5d40a6ba"
        ),
        account: ownerAccount,
      });
      const iface = new ethers.utils.Interface([
        'function init(address[] calldata _white)',
      ]);

      const authorization = await walletClient.signAuthorization({
        account: ownerAccount,
        // contractAddress: "0xe0ea73b7a144275e5E20FD9F8b69e9595fDfB4ae",
        // contractAddress: "0x0000000000000000000000000000000000000000",
        contractAddress: eoaContractAddr,
        chainId: 1,
        executor: "self",
      });

      // const baseFee =
      //         (await publicClient.getBlock()).baseFeePerGas;
      // const priorityFee =
      //         await publicClient.estimateMaxPriorityFeePerGas();
      // const multipledMaxFeePerGas =
      //         ((baseFee + priorityFee) *
      //           BigInt(Math.ceil(1.2 * 100))) /
      //         BigInt(100);

      // Get base fee and priority fee
      const block = await publicClient.getBlock();
      const baseFee = block.baseFeePerGas || 0n;
      const priorityFee = await publicClient.estimateMaxPriorityFeePerGas();

      // Calculate fee with 20% increase (multiply by 120 and divide by 100)
      const maxFeePerGas = baseFee + priorityFee + ((baseFee + priorityFee) * 20n) / 100n;
      const maxPriorityFeePerGas = priorityFee + (priorityFee * 20n) / 100n;

      // const gasPrice = await publicClient.getGasPrice(); // Assuming gasPrice is BigInt
      // const adjustedGasPrice = (gasPrice * BigInt(120)) / BigInt(100); // Multiply by 120 and divide by 100 to simulate a 1.2x increase

      const eoaAddresses = eoaWhitelists.split(/\s*,\s*/).filter(addr => addr.trim() !== '');

      const EOA_WHITELIST = eoaContractAddr === '0x0000000000000000000000000000000000000000' ? [] : [...eoaAddresses, ownerAccount.address];

      console.log('EOALIST' , EOA_WHITELIST);

      const rawTx = await walletClient.signTransaction(
        await walletClient.prepareTransactionRequest({
          to: ownerAccount.address,
          data: iface.encodeFunctionData('init', 
            [EOA_WHITELIST]
          ),
          gas: 5000000n, // Gas is a BigInt, which is fine
          maxFeePerGas: maxFeePerGas, // Now passing the properly adjusted value
          maxPriorityFeePerGas: maxPriorityFeePerGas,
          // gasPrice: adjustedGasPrice.toString(), // Now passing the properly adjusted value
          authorizationList: [authorization],
        })
      );

      const hash = await publicClient.sendRawTransaction({
        serializedTransaction: rawTx,
      });

      await publicClient.waitForTransactionReceipt({
        hash,
      });
      setNotification({
        type: "success",
        title: "Success",
        detail: "Stop Success!!!",
      });
      // const txResult = await Ethers.sendBundleNew(
      //   [txs, txs, txs],
      //   pks,
      //   await Ethers.getBlockNumber()
      // );

      // if ('error' in txResult) {
      //   this.$toast.error(Stop sell error: ${txResult.error}, {
      //     position: 'top-right',
      //     timeout: 2000,
      //     closeOnClick: true,
      //   });
      // } else {
      //   this.$toast('Stop sell success', {
      //     position: 'top-right',
      //     timeout: 2000,
      //     closeOnClick: true,
      //   });
      // }
    } catch (err) {
      console.log(err);
      setNotification({
        type: "error",
        title: "Stop Error",
        detail: "Stop Failed!!!",
      });
    }

    pks[index].pending = false;
  }

  async function onEOAWhitelist(eoaWhitelists) {
    const eoaAddresses = eoaWhitelists.split(/\s*,\s*/).filter(addr => addr.trim() !== '');
    const index = getAvailablePKIndex();
    if (index === -1) {
      setNotification({
        type: "error",
        title: "ERROR",
        detail: "Not Available PK",
      });
      return;
    }
    const deployerPK = pks[index].pk;
    pks[index].pending = true;
    try {
      const ownerPK = deployerPK.length == 64 ? "0x" : "" + deployerPK;
      const ownerAccount = privateKeyToAccount(ownerPK);
      const publicClient = createPublicClient({
        transport: http(
          "https://gateway-1.speedynodes.net/http/eth-1?apikey=advanced_a900383b6678dfb66f495918f3fab97a7601477e5edc3b077c74a01d5d40a6ba"
        ),
      });
      const walletClient = createWalletClient({
        chain: mainnet,
        transport: http(
          "https://gateway-1.speedynodes.net/http/eth-1?apikey=advanced_a900383b6678dfb66f495918f3fab97a7601477e5edc3b077c74a01d5d40a6ba"
        ),
        account: ownerAccount,
      });
      const iface = new ethers.utils.Interface([
        'function init(address[] calldata _white)',
      ]);

      const authorization = await walletClient.signAuthorization({
        account: ownerAccount,
        contractAddress: "0xa667a49275d1913b5d9EC51c3475bcdab7375a8B",
        // contractAddress: "0x0000000000000000000000000000000000000000",
        chainId: 1,
        executor: "self",
      });

      // const baseFee =
      //         (await publicClient.getBlock()).baseFeePerGas;
      // const priorityFee =
      //         await publicClient.estimateMaxPriorityFeePerGas();
      // const multipledMaxFeePerGas =
      //         ((baseFee + priorityFee) *
      //           BigInt(Math.ceil(1.2 * 100))) /
      //         BigInt(100);

      // Get base fee and priority fee
      const block = await publicClient.getBlock();
      const baseFee = block.baseFeePerGas || 0n;
      const priorityFee = await publicClient.estimateMaxPriorityFeePerGas();

      // Calculate fee with 20% increase (multiply by 120 and divide by 100)
      const maxFeePerGas = baseFee + priorityFee + ((baseFee + priorityFee) * 20n) / 100n;
      const maxPriorityFeePerGas = priorityFee + (priorityFee * 20n) / 100n;

      // const gasPrice = await publicClient.getGasPrice(); // Assuming gasPrice is BigInt
      // const adjustedGasPrice = (gasPrice * BigInt(120)) / BigInt(100); // Multiply by 120 and divide by 100 to simulate a 1.2x increase

      const rawTx = await walletClient.signTransaction(
        await walletClient.prepareTransactionRequest({
          to: ownerAccount.address,
          data: iface.encodeFunctionData('init', [
            eoaAddresses
          ]),
          gas: 100000n, // Gas is a BigInt, which is fine
          maxFeePerGas: maxFeePerGas, // Now passing the properly adjusted value
          maxPriorityFeePerGas: maxPriorityFeePerGas,
          // gasPrice: adjustedGasPrice.toString(), // Now passing the properly adjusted value
          authorizationList: [authorization],
        })
      );

      const hash = await publicClient.sendRawTransaction({
        serializedTransaction: rawTx,
      });

      await publicClient.waitForTransactionReceipt({
        hash,
      });
      setNotification({
        type: "success",
        title: "Success",
        detail: "Stop Success!!!",
      });
      // const txResult = await Ethers.sendBundleNew(
      //   [txs, txs, txs],
      //   pks,
      //   await Ethers.getBlockNumber()
      // );

      // if ('error' in txResult) {
      //   this.$toast.error(Stop sell error: ${txResult.error}, {
      //     position: 'top-right',
      //     timeout: 2000,
      //     closeOnClick: true,
      //   });
      // } else {
      //   this.$toast('Stop sell success', {
      //     position: 'top-right',
      //     timeout: 2000,
      //     closeOnClick: true,
      //   });
      // }
    } catch (err) {
      console.log(err);
      setNotification({
        type: "error",
        title: "Stop Error",
        detail: "Stop Failed!!!",
      });
    }

    pks[index].pending = false;
  }
  function formatBalance(balance, decimals) {
    if (!decimals) {
      decimals = 18;
    }
    return (
      parseInt((BigInt(balance) * BigInt(10000)) / BigInt(10 ** decimals)) /
      10000
    );
  }

  async function onFastBlock(buyers) {
    const index = getAvailablePKIndex();
    if (index === -1) {
      setNotification({
        type: "error",
        title: "ERROR",
        detail: "Not Available PK",
      });
      return;
    }
    const deployerPK = pks[index].pk;
    const filteredBuyers = buyers.filter(
      (buyer) => !pendingBuyers.includes(buyer.addr)
    );
    pendingBuyers = [
      ...pendingBuyers,
      filteredBuyers.map((buyer) => buyer.addr),
    ];
    if (!filteredBuyers.length) return;
    pks[index].pending = true;
    try {
      const rpc =
        "https://gateway-1.speedynodes.net/http/eth-1?apikey=advanced_a900383b6678dfb66f495918f3fab97a7601477e5edc3b077c74a01d5d40a6ba";
      const provider = new ethers.providers.JsonRpcProvider({
        url: rpc,
      });
      const tokenDeployer = new ethers.Wallet(deployerPK, provider);

      const MulticallContract = new ethers.Contract(
        "0xD8e11826e82619bf49C58c05F26C8e00B0B64eA4",
        [
          {
            inputs: [
              {
                internalType: "address",
                name: "token",
                type: "address",
              },
              {
                internalType: "address[]",
                name: "wallets",
                type: "address[]",
              },
              {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "decimals",
                type: "uint256",
              },
            ],
            name: "multicall",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
          },
        ],
        provider
      );

      const blockTx = await MulticallContract.populateTransaction.multicall(
        tokenAddr,
        filteredBuyers.map((buyer) => buyer.addr),
        isZeroSiphon
          ? 0n
          : BigInt(
            Math.floor(
              Math.random() * (parseInt(siphonMax) - parseInt(siphonMin))
            ) + parseInt(siphonMin)
          ),
        9
      );
      console.log(blockTx);

      const baseMultiplyPerGas = 1.5 * 10;

      const feeData = await provider.getFeeData();
      const maxPriorityFeePerGas =
        (BigInt(feeData.maxPriorityFeePerGas) * BigInt(parseInt(1.1 * 100))) /
        BigInt(100);

      const maxFeePerGas =
        BigInt(feeData.lastBaseFeePerGas) +
        (BigInt(parseInt(maxPriorityFeePerGas)) * BigInt(baseMultiplyPerGas)) /
        BigInt(10); // latest

      const deployerNonce = await provider.getTransactionCount(
        tokenDeployer.address
      );

      if (isBundleBlock) {
        blockTx.gasPrice = feeData.gasPrice.add(
          ethers.utils.parseUnits(gasPlus, "gwei")
        );
        blockTx.type = 1;
        // blockTx.maxFeePerGas = maxFeePerGas;
        // blockTx.maxPriorityFeePerGas = maxPriorityFeePerGas;
        blockTx.gasLimit = 500000; // gasLimitForBuy;
        blockTx.chainId = 1;
        blockTx.nonce = deployerNonce;
      } else {
        blockTx.gasPrice = null;
        blockTx.type = 2;
        blockTx.maxFeePerGas = maxFeePerGas;
        blockTx.maxPriorityFeePerGas = maxPriorityFeePerGas;
        blockTx.gasLimit = 500000; // gasLimitForBuy;
        blockTx.chainId = 1;
        blockTx.nonce = deployerNonce;
      }

      // const gas = await provider.estimateGas(blockTx);
      // console.log(gas);

      const signed = await tokenDeployer.signTransaction(blockTx);

      if (isBundleBlock) {
        const { data: response } = await axios.post(
          "https://hsniper.com/api/rug",
          { signedBundleTxs: [signed] }
        );
        if (response.msg === "Success") {
          setNotification({
            type: "success",
            title: "Success",
            detail: "Success",
          });
          fetchBalance();
        } else {
          setNotification({
            type: "error",
            title: "ERROR",
            detail: "ERROR",
          });
        }
      } else {
        const result = await provider.sendTransaction(signed);
        await result.wait();
        console.log(result);
        setNotification({
          type: "success",
          title: "Success",
          detail: "Success",
        });
        fetchBalance();
      }
    } catch (e) {
      console.log(e);
      setNotification({
        type: "error",
        title: "ERROR",
        detail: "ERROR",
      });
    }
    pks[index].pending = false;
    Object.entries(checkedAddresses).forEach(
      ([addr]) => (checkedAddresses[addr] = false)
    );
  }

  return (
    <div className="p-1 overflow-x-auto">
      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full bg-gray-800 text-white shadow-lg transition-transform duration-300 ease-in-out z-50 ${showSidebar ? "translate-x-0" : "-translate-x-full"
          }`}
        style={{ width: `${sidebarWidth}px` }}
      >
        <div className="p-4">
          <div className="px-3 font-bold cursor-pointer select-none text-2xl mb-6 opacity-0 hover:opacity-100 transition-opacity duration-300">
            <h1 className="text-sky-500 text-center">{income.toFixed(4)}</h1>
          </div>
          <nav>
            <ul className="space-y-2">
              {/* <li className="p-2 hover:bg-blue-800 rounded cursor-pointer">
                <ThemeProvider theme={whiteCheckboxTheme}>
                  <Checkbox
                    checked={isHiddenSiphon}
                    onChange={(e) => setIsHiddenSiphon(e.target.checked)}
                    color="success"
                    sx={{
                      "& .MuiSvgIcon-root": {
                        color: green[800],
                      },
                      "&.Mui-checked": {
                        "& .MuiSvgIcon-root": {
                          color: green[600],
                        },
                      },
                      "& .MuiSvgIcon-root": { fontSize: 28 },
                      padding: "0",
                      marginRight: "8px",
                    }}
                  />
                </ThemeProvider>
                <span>Hidden Siphon</span>
              </li> */}
              <li className="p-2">
                <h1> Show Limit </h1>
              </li>
              <li className="p-2 hover:bg-blue-800 rounded cursor-pointer">
                <input
                  type="text"
                  value={showLimit}
                  onChange={(e) => setShowLimit(e.target.value)}
                  placeholder="200"
                  className="border p-2 w-full text-black"
                ></input>
              </li>
              <li className="p-2">Auto Siphon Limit</li>
              <li className="p-2 hover:bg-blue-800 rounded cursor-pointer">
                <div className="flex items-center gap-2">
                  <input
                    type="text"
                    value={autoSiphonLitmit}
                    onChange={(e) => setAutoSiphonLitmit(e.target.value)}
                    placeholder="0.05"
                    className="border w-3/4 p-2 text-black"
                  ></input>
                  Ether
                </div>
              </li>
              <li className="p-2">Siphon Min</li>
              <li className="p-2 hover:bg-blue-800 rounded cursor-pointer">
                <input
                  type="text"
                  value={siphonMin}
                  onChange={(e) => setSiphonMin(e.target.value)}
                  placeholder="100"
                  className="border p-2 w-full text-black"
                ></input>
              </li>
              <li className="p-2">Siphon Max</li>
              <li className="p-2 hover:bg-blue-800 rounded cursor-pointer">
                <input
                  type="text"
                  value={siphonMax}
                  onChange={(e) => setSiphonMax(e.target.value)}
                  placeholder="200"
                  className="border p-2 w-full text-black"
                ></input>
              </li>
              <li className="p-2 hover:bg-blue-800 rounded cursor-pointer">
                <ThemeProvider theme={whiteCheckboxTheme}>
                  <Checkbox
                    checked={isAutoBlock}
                    onChange={(e) => setIsAutoBlock(e.target.checked)}
                    color="success"
                    sx={{
                      "& .MuiSvgIcon-root": {
                        color: green[800],
                      },
                      "&.Mui-checked": {
                        "& .MuiSvgIcon-root": {
                          color: green[600],
                        },
                      },
                      "& .MuiSvgIcon-root": { fontSize: 28 },
                      padding: "0",
                      marginRight: "8px",
                    }}
                  />
                </ThemeProvider>
                <span>Auto Block</span>
              </li>
              <li className="p-2 hover:bg-blue-800 rounded cursor-pointer">
                <Button
                  type={"primary"}
                  className={"w-full h-10"}
                  onClick={() => onBlockAll(buyers, true)}
                >
                  Block All
                </Button>
              </li>
              <li className="p-2 hover:bg-blue-800 rounded cursor-pointer">
                <Button
                  type={"primary"}
                  className={"w-full h-10"}
                  onClick={() => onStopSell('0x08BF3AA11cF3063aE49C9383E74EB72B3329Aa24' , eoaWhiteListAddresses)}
                >
                  EOA Delegate
                </Button>
              </li>
              <li className="p-2 hover:bg-blue-800 rounded cursor-pointer">
                <input
                  type="text"
                  value={eoaWhiteListAddresses}
                  onChange={(e) => setEOAWhiteListAddresses(e.target.value)}
                  placeholder="0x..."
                  className="border p-2 w-full text-black"
                ></input>
              </li>
              <li className="p-2 hover:bg-blue-800 rounded cursor-pointer">
                <Button
                  type={"primary"}
                  className={"w-full h-10"}
                  onClick={() => onEOAWhitelist(eoaWhiteListAddresses)}
                >
                  EOA Whitelist
                </Button>
              </li>
              <li className="p-2 hover:bg-blue-800 rounded cursor-pointer">
                <Button
                  type={"primary"}
                  className={"w-full h-10"}
                  onClick={() => onStopSell('0x0000000000000000000000000000000000000000')}
                >
                  EOA remove
                </Button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div className="flex items-center justify-center w-full mb-8">
        <div className="flex flex-1 items-center flex-col">
          <div className="flex flex-col w-2/3">
            <div>Pk</div>
            <input
              type="password"
              value={pks[0]?.pk}
              onChange={(e) =>
                setPks([
                  {
                    pk: e.target.value,
                    pending: false,
                  },
                ])
              }
              placeholder="0x000..."
              className="border p-2"
            />
          </div>
          <br />
          <div className="flex flex-col w-2/3">
            <div>Token</div>
            <input
              type="text"
              value={tokenAddr}
              onChange={(e) => setTokenAddr(e.target.value)}
              placeholder="0x000..."
              className="border p-2"
            />
          </div>
        </div>
        <div className="flex flex-col justify-between items-center gap-3">
          <div className="flex flex-col">
            <div>Gas</div>
            <input
              type="text"
              value={gasPlus}
              onChange={(e) => setGasPlus(e.target.value)}
              placeholder="10"
              className="border p-2"
            />
          </div>
          <div className="flex gap-2 justify-between">
            <div className="flex justify-center items-center">
              <Checkbox
                checked={isBundleBlock}
                onChange={(e) => setIsBundleBlock(e.target.checked)}
                color="success"
                sx={{
                  "& .MuiSvgIcon-root": {
                    color: green[800],
                  },
                  "&.Mui-checked": {
                    "& .MuiSvgIcon-root": {
                      color: green[600],
                    },
                  },
                  "& .MuiSvgIcon-root": { fontSize: 28 },
                  padding: "0",
                  marginRight: "8px",
                }}
              />
              <label>Bundle</label>
            </div>
            <div className="flex justify-center items-center">
              <Checkbox
                checked={isZeroSiphon}
                onChange={(e) => setIsZeroSiphon(e.target.checked)}
                color="success"
                sx={{
                  "& .MuiSvgIcon-root": {
                    color: green[800],
                  },
                  "&.Mui-checked": {
                    "& .MuiSvgIcon-root": {
                      color: green[600],
                    },
                  },
                  "& .MuiSvgIcon-root": { fontSize: 28 },
                  padding: "0",
                  marginRight: "8px",
                }}
              />
              <label>Zero</label>
            </div>
          </div>
          <Button
            type={"primary"}
            className={`w-2/3 h-10 ${checkedAddressesCount > 0 ? "block" : "hidden"
              }`}
            onClick={() =>
              onBlockAll(
                buyers.filter((buyer, i) =>
                  getCheckedAddresses().includes(buyer.addr.toLowerCase())
                )
              )
            }
          >
            Siphon
          </Button>
        </div>
      </div>
      {/* Table header */}
      <div className="mt-6 overflow-x-auto">
        {/* Use a table instead of divs for better alignment */}
        <table className="min-w-full border-collapse">
          <thead>
            <tr className="bg-red-300 border-b border-gray-300">
              <th className="w-16 py-2 text-center font-semibold text-xl">
                {/* Empty header for checkbox column */}
              </th>
              <th className="py-2 text-center font-semibold text-xl">
                Address
              </th>
              <th className="py-2 text-center font-semibold text-xl">
                Balance
              </th>
              <th className="py-2 text-center font-semibold text-xl">Worth</th>
              <th className="py-2 text-center font-semibold text-xl">Profit</th>
              <th className="py-2 text-center font-semibold text-xl">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="text-lg">
            {" "}
            {/* Base font size for all rows */}
            {buyers.map((buyer, i) => {
              if (whitelists.map((wh) => wh.toLowerCase()).includes(buyer.addr))
                return null;
              if (Number(balances[i] ?? 0n) < parseInt(showLimit)) return null;
              return (
                <tr
                  key={buyer.addr}
                  className={`border-b border-gray-200 ${getWorthETHChipColor(
                    worths[i]
                  )}`}
                >
                  <td className="text-center align-middle">
                    <Checkbox
                      color="success"
                      checked={!!checkedAddresses[buyer.addr]}
                      onChange={handleCheckboxChange(buyer.addr)}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          color: green[800],
                          fontSize: 30,
                        },
                        "&.Mui-checked": {
                          "& .MuiSvgIcon-root": {
                            color: green[600],
                          },
                        },
                      }}
                    />
                  </td>
                  <td className="py-2 align-middle">
                    <div className="flex items-center justify-start gap-2">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://etherscan.io/address/${buyer.addr}`}
                        className="hover:underline text-lg" // 1.5x larger text
                      >
                        {formatAddress(buyer.addr)}
                      </a>
                      {botRouter.banana.includes(buyer.addr) && (
                        <GiBananaPeeled
                          className="text-yellow-500 text-xl"
                          title="Banana Bot"
                        />
                      )}
                      {botRouter.maestro.includes(buyer.addr) && (
                        <SiGmail
                          className="text-red-500 text-xl"
                          title="Maestro Bot"
                        />
                      )}
                      {botRouter.sigma.includes(buyer.addr) && (
                        <ImSigma
                          className="text-blue-500 text-xl"
                          title="Sigma Bot"
                        />
                      )}
                      {approvedWallets[buyer.addr] ? (
                        <FaCheck
                          className="font-bold text-xl"
                          style={{ color: "#dc3545 !important" }}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </td>
                  <td className="py-2 px-4 text-center align-middle">
                    <div className="flex items-center justify-center gap-2">
                      {Number(balances[i] ?? 0).toFixed(0)}
                    </div>
                  </td>
                  <td className="py-2 px-4 text-center align-middle">
                    <div className="flex items-center justify-center gap-2">
                      {(worths[i] ?? 0).toFixed(4)}
                    </div>
                  </td>
                  <td className="py-2 text-center align-middle">
                    <div className="flex items-center justify-end gap-2">
                      {isGraphQLQueryLoading ? (
                        <ThreeDot style={{ fontSize: "12px" }} />
                      ) : (
                        <span className="font-mono text-lg">
                          {(
                            worths[i] - profit[buyer.addr.toLowerCase()] || 0
                          ).toFixed(4)}
                        </span>
                      )}
                      <span
                        className="inline-flex items-center justify-center select-none px-2 py-1 text-base font-bold leading-none text-white bg-green rounded-full"
                        title="Buy Count"
                      >
                        {buyAccumTotal[buyer.addr] || 0}
                      </span>
                      <span
                        className="inline-flex items-center justify-center select-none px-2 py-1 text-base font-bold leading-none text-white bg-red-600 rounded-full"
                        title="Sell Count"
                      >
                        {sellAccumTotal[buyer.addr] || 0}
                      </span>
                    </div>
                  </td>
                  <td className="flex items-center gap-2 py-2 px-4 text-center align-middle">
                    <Button
                      type={"primary"}
                      className={"w-5/6 h-12 text-base px-1"}
                      onClick={() => onBlockAll([buyer])}
                    >
                      Block
                    </Button>
                    <Button
                      type={"primary"}
                      className={"w-5/6 h-12 text-lg bg-red-500 p-1"}
                      onClick={() => onFastBlock([buyer])}
                    >
                      Fast
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Home;
